import React, { useState } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  Button,
  useDisclosure,
  IconButton,
  Spinner,
} from "@chakra-ui/react";

import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";

import { PatchToggleFavouriteSupplier } from "services/SuppliersService";

export default function FavouriteSupplier(props) {
  const { is_favourite, supplierName, user_supplier_id } = props;

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [isFavourite, setIsFavourite] = useState(is_favourite);
  const [isLoading, setIsLoading] = useState(false);

  const handleToggleFavourite = async (user_supplier_id) => {
    console.log("user_supplier_id", user_supplier_id);

    setIsLoading(true);

    try {
      await PatchToggleFavouriteSupplier(user_supplier_id);
      if (isOpen) {
        onClose();
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }

    setIsFavourite(!isFavourite);
  };

  return (
    <>
      {isFavourite ? (
        <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose}>
          <PopoverTrigger>
            <IconButton
              variant="ghost"
              isDisabled={isLoading}
              icon={
                isLoading ? (
                  <Spinner size={"sm"} />
                ) : (
                  <div className="secondary-color-text">
                    <StarIcon />
                  </div>
                )
              }
            />
          </PopoverTrigger>
          <PopoverContent>
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverHeader className="text-red-500">
              Confirmation!
            </PopoverHeader>
            <PopoverBody>
              <div className="flex flex-col">
                Are you sure you want to remove {supplierName} from your
                favourites?
              </div>
            </PopoverBody>
            <PopoverFooter>
              <div className="flex flex-row gap-2 ">
                <div className="w-fit">
                  <Button
                    sx={{ height: "2.5rem" }}
                    colorScheme="red"
                    variant="solidMini"
                    size="sm"
                    onClick={() => {
                      handleToggleFavourite(user_supplier_id);
                    }}
                    isDisabled={isLoading}
                  >
                    {isLoading ? <Spinner size={"sm"} /> : "Remove"}
                  </Button>
                </div>
                <div className="w-fit">
                  <Button
                    sx={{ height: "2.5rem" }}
                    colorScheme="red"
                    variant="outlineMini"
                    size="sm"
                    isDisabled={isLoading}
                    onClick={(e) => {
                      onClose();
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </PopoverFooter>
          </PopoverContent>
        </Popover>
      ) : (
        <IconButton
          variant="ghost"
          icon={
            isLoading ? (
              <Spinner size={"sm"} />
            ) : (
              <div className="secondary-color-text">
                <StarBorderIcon />
              </div>
            )
          }
          onClick={() => {
            handleToggleFavourite(user_supplier_id);
          }}
          isDisabled={isLoading}
        />
      )}
    </>
  );
}
